<template>
  <section id="register">
    <div class="content">
      <h3>JOFPH&nbsp;&nbsp;后台管理</h3>
      <h5>用户注册</h5>
      <a-form :form="form" @submit="handleSubmit" layout="horizontal">
        <a-form-item>
          <div class="input">
            <a-icon type="user" />
            <input
              placeholder="请输入用户账号"
              v-decorator="[
                'username',
                {
                  rules: [
                    {
                      required: true,
                      message: '账号不得为空!',
                    },
                  ],
                },
              ]"
            />
          </div>
        </a-form-item>
        <a-form-item>
          <div class="input">
            <a-icon type="lock" />
            <input
              placeholder="请输入用户密码"
              type="password"
              v-decorator="[
                'password',
                {
                  rules: [
                    {
                      required: true,
                      message: '密码不得为空!',
                    },
                  ],
                },
              ]"
            />
          </div>
        </a-form-item>
        <a-form-item>
          <div class="input">
            <a-icon type="lock" />
            <input
              placeholder="请确认用户密码"
              type="password"
              v-decorator="[
                'repassword',
                {
                  rules: [
                    {
                      required: true,
                      message: '确认密码不得为空!',
                    },
                    {
                      validator: compareToFirstPassword,
                    },
                  ],
                },
              ]"
            />
          </div>
        </a-form-item>
        <a-form-item>
          <div class="input">
            <a-icon type="smile" />
            <input
              placeholder="请输入用户姓名"
              v-decorator="[
                'nickname',
                {
                  rules: [
                    {
                      required: true,
                      message: '用户姓名不得为空!',
                    },
                  ],
                },
              ]"
            />
          </div>
        </a-form-item>
        <a-form-item>
          <div class="input">
            <a-icon type="mail" />
            <input
              placeholder="请输入邮箱地址"
              v-decorator="[
                'email',
                {
                  rules: [
                    {
                      type: 'email',
                      message: '请输入正确的邮箱地址!',
                    },
                    {
                      required: true,
                      message: '邮箱地址不得为空!',
                    },
                  ],
                },
              ]"
            />
          </div>
        </a-form-item>
        <!-- <a-form-item>
          <a-input placeholder="请输入用户手机号"
                   style="width: 100%"
                   size="large"
                   v-decorator="[
                            'phoneNum',
                        ]" />
        </a-form-item> -->
        <router-link to="/access/login">返回登录</router-link>
        <a-form-item>
          <a-button type="primary" html-type="submit"> 立即注册 </a-button>
        </a-form-item>
      </a-form>
    </div>
    <!-- <div class="warp"
         id="particle-canvas">
      <div>
        <h1>IMR-数据中心</h1>
      </div>
    </div> -->
  </section>
</template>

<script>
import register from "./register.js";
export default register;
</script>

<style lang="scss" scoped>
@import "./register.scss";
</style>
